import { InputRegexMap, OnboardingFormFields } from '@Types/index.ts';
import { t } from 'i18next';
import { ControlledTextInput } from './ControlledInputs';
import { z } from 'zod';
const MIN_NAME_CHARS = 2;
const MAX_NAME_CHARS = 30;
interface IProps {
  disabled: boolean;
  tabIndex: number;
}
export const FirstNameInput = ({ disabled, tabIndex }: IProps) => {
  return (
    <ControlledTextInput
      name={OnboardingFormFields.FIRST_NAME}
      title={t('pages.home.firstName')}
      id={OnboardingFormFields.FIRST_NAME}
      disabled={disabled}
      tabindex={tabIndex}
    />
  );
};

export const firstNameScheme = z.object({
  [OnboardingFormFields.FIRST_NAME]: z
    .string()
    .trim()
    .min(1, t('enErrors:personalDetails.firstNameRequired'))
    .min(MIN_NAME_CHARS, t('enErrors:personalDetails.firstNameMinChars'))
    .max(MAX_NAME_CHARS, t('enErrors:firstNameTooLong'))
    .regex(InputRegexMap.firstName, t('enErrors:personalDetails.firstNameNonLetters')),
});
